import { toast } from 'react-toastify';
import { CustomError } from 'shared/api';

export const showError = (error: CustomError) => {
	if (error) {
		let errorText;
		if (error.code === 'ERR_NETWORK') {
			errorText = 'Вы не в сети!';
			return;
		}

		switch (error.status) {
			case 500:
				errorText = 'Ошибка! Отправить данные не удалось.';
				break;
			case 400:
				errorText =
					'Статус 400 Bad Request';
				break;
			case 401:
				errorText =
					'Ошибка Авторизации! Пожалуйста авторизуйтесь и попробуйте снова.';
				break;
			default:
				errorText =
					'Извините кажется произошла ошибка. Не верный запрос.';
		}

		toast.error(errorText);
	}
};
